<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item @click="goToUsers">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
              <md-badge
                class="md-square md-warning"
                md-content="Verifizieren"
                v-if="
                  club &&
                    club.has_mobile_verification_api &&
                    user &&
                    user.mobile &&
                    !user.mobile_verified_at
                "
              />
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters["profile/me"];
    },
    club() {
      return this.$store.getters["clubs/club"];
    }
  },
  watch: {
    user: {
      handler() {
        this.getClub();
      },
      immediate: true
    }
  },
  methods: {
    async getClub() {
      if (
        this.club &&
        this.user &&
        this.user.club_id &&
        (!this.club.id || this.club.id !== this.user.club_id)
      ) {
        this.$store.dispatch("clubs/get", this.user.club_id);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    goToNotifications() {
      this.$router.push({ name: "Notifications" });
    },
    goToUsers() {
      this.$router.push({ name: "Userprofil" });
    }
  }
};
</script>
